import React, { useContext } from 'react'
import { ReducerDispatchContext, ReducerContext } from '../reducers/reducerContext.js';
import { fetchFinanceFileIfNeeded } from '../actions/actionsApiFinanceFile'
import FinanceFileButton from '../components/results/FinanceFileButton'

export default function ContFinanceFileButton() {
  const dispatch = useContext(ReducerDispatchContext);
  const globalstate = useContext(ReducerContext);

  function onOpen() {
    fetchFinanceFileIfNeeded(globalstate, dispatch, null, null, null);
  }

  return (
    <FinanceFileButton
      vehicleDetails={globalstate.responseSimulation.vehicleDetails}
      onOpen={onOpen}
    />
  );
}
